import React from "react";
import PropTypes from "prop-types";
import { Menu } from "@mui/material";

/**
 * MenuComponent
 * Centralized MUI Menu with consistent Paper styling.
 * Defaults to inherited font (or pass "Source Sans Pro, sans-serif").
 */
function MenuComponent({
  anchorEl,
  open,
  onClose,
  children,
  width = 200,
  zIndex = 1300,
  fontFamily = "inherit",
  paperSx = {},
  listSx = {},
  anchorOrigin = { vertical: "bottom", horizontal: "left" },
  transformOrigin,
  ...rest
}) {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      sx={{ "& .MuiList-root": { p: 0, ...listSx } }}
      PaperProps={{
        sx: {
          border: "1px solid #ECF3FE",
          boxShadow: "4px 4px 15px rgba(65, 92, 171, 0.15)",
          backgroundColor: "#FFFFFF",
          width,
          zIndex,
          fontFamily,
          "& *": { fontFamily: "inherit" },
          ...paperSx,
        },
      }}
      {...rest}
    >
      {children}
    </Menu>
  );
}

MenuComponent.propTypes = {
  anchorEl: PropTypes.any,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
  width: PropTypes.number,
  zIndex: PropTypes.number,
  fontFamily: PropTypes.string,
  paperSx: PropTypes.object,
  listSx: PropTypes.object,
  anchorOrigin: PropTypes.object,
  transformOrigin: PropTypes.object,
};

export default MenuComponent;
